import qs from 'qs';

import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async findAddressesByPostcode({ postcode }) {
    const response = await axiosPrivate.get(`/v3/location/addresses-by-postcode/${postcode}`);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },
};
